import { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  heading: string;
}>;
export const LearningOpportunityInfoMessage = (props: Props) => {
  return (
    <div className="bg-light-yellow text-text-primary p-md rounded-2">
      <div className="mb-2xs">
        <h5 className="text-style-subtitle1 text-grey-160">{props.heading}</h5>
      </div>
      <p className="text-style-body2">{props.children}</p>
    </div>
  );
};
